/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { BusinessType } from './BusinessType';
import {
    BusinessTypeFromJSON,
    BusinessTypeFromJSONTyped,
    BusinessTypeToJSON,
    BusinessTypeToJSONTyped,
} from './BusinessType';
import type { MerchantBrandSize } from './MerchantBrandSize';
import {
    MerchantBrandSizeFromJSON,
    MerchantBrandSizeFromJSONTyped,
    MerchantBrandSizeToJSON,
    MerchantBrandSizeToJSONTyped,
} from './MerchantBrandSize';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface CreateBusinessBody
 */
export interface CreateBusinessBody {
    /**
     * 
     * @type {BusinessType}
     * @memberof CreateBusinessBody
     */
    type?: BusinessType;
    /**
     * 
     * @type {MerchantBrandSize}
     * @memberof CreateBusinessBody
     */
    brandSize?: MerchantBrandSize;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    parent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    internalName?: string;
    /**
     * See moment.tz.names()
     * @type {string}
     * @memberof CreateBusinessBody
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBusinessBody
     */
    specialInstructions?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateBusinessBody
     */
    prepTime?: number;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof CreateBusinessBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {Address}
     * @memberof CreateBusinessBody
     */
    address: Address;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBusinessBody
     */
    taxonomies?: Array<string>;
    /**
     * 
     * @type {Array<HandoffOptions>}
     * @memberof CreateBusinessBody
     */
    handoffOptions?: Array<HandoffOptions>;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    firstDeliveryId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    merchantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    headerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBusinessBody
     */
    stripeAccountId?: string;
}



/**
 * Check if a given object implements the CreateBusinessBody interface.
 */
export function instanceOfCreateBusinessBody(value: object): value is CreateBusinessBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CreateBusinessBodyFromJSON(json: any): CreateBusinessBody {
    return CreateBusinessBodyFromJSONTyped(json, false);
}

export function CreateBusinessBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBusinessBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : BusinessTypeFromJSON(json['type']),
        'brandSize': json['brandSize'] == null ? undefined : MerchantBrandSizeFromJSON(json['brandSize']),
        'parent': json['parent'] == null ? undefined : json['parent'],
        'name': json['name'],
        'internalName': json['internalName'] == null ? undefined : json['internalName'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'description': json['description'] == null ? undefined : json['description'],
        'email': json['email'] == null ? undefined : json['email'],
        'specialInstructions': json['specialInstructions'] == null ? undefined : json['specialInstructions'],
        'prepTime': json['prepTime'] == null ? undefined : json['prepTime'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'address': AddressFromJSON(json['address']),
        'taxonomies': json['taxonomies'] == null ? undefined : json['taxonomies'],
        'handoffOptions': json['handoffOptions'] == null ? undefined : ((json['handoffOptions'] as Array<any>).map(HandoffOptionsFromJSON)),
        'firstDeliveryId': json['firstDeliveryId'] == null ? undefined : json['firstDeliveryId'],
        'merchantId': json['merchantId'] == null ? undefined : json['merchantId'],
        'website': json['website'] == null ? undefined : json['website'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'headerImage': json['headerImage'] == null ? undefined : json['headerImage'],
        'stripeAccountId': json['stripeAccountId'] == null ? undefined : json['stripeAccountId'],
    };
}

export function CreateBusinessBodyToJSON(json: any): CreateBusinessBody {
    return CreateBusinessBodyToJSONTyped(json, false);
}

export function CreateBusinessBodyToJSONTyped(value?: CreateBusinessBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': BusinessTypeToJSON(value['type']),
        'brandSize': MerchantBrandSizeToJSON(value['brandSize']),
        'parent': value['parent'],
        'name': value['name'],
        'internalName': value['internalName'],
        'timeZone': value['timeZone'],
        'currency': value['currency'],
        'description': value['description'],
        'email': value['email'],
        'specialInstructions': value['specialInstructions'],
        'prepTime': value['prepTime'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'address': AddressToJSON(value['address']),
        'taxonomies': value['taxonomies'],
        'handoffOptions': value['handoffOptions'] == null ? undefined : ((value['handoffOptions'] as Array<any>).map(HandoffOptionsToJSON)),
        'firstDeliveryId': value['firstDeliveryId'],
        'merchantId': value['merchantId'],
        'website': value['website'],
        'icon': value['icon'],
        'headerImage': value['headerImage'],
        'stripeAccountId': value['stripeAccountId'],
    };
}

